import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "reservations";
const addNewReservations = (reservation) => axios.post(baseURL, reservation);
const rePushReservations = (reservationId) => axios.get(baseURL + `/repush_to_branch/${reservationId}`);

export {
    addNewReservations,
    rePushReservations
}